var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_TV_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.686,
    height: 16.348,
    viewBox: "0 0 94.686 16.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1832",
    "data-name": "Group 1832",
    transform: "translate(25.264 0.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M2371.252,60.418v9.357h-1.363V60.418H2366.9V59.1h7.327v1.318Z",
    transform: "translate(-2314.777 -57.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M2623.482,70.472h-1.432L2618.3,59.8h1.527l2.923,8.661h.065l3.037-8.661h1.527Z",
    transform: "translate(-2557.958 -58.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M778.824,35.491a6.046,6.046,0,1,1,0-12.091,5.783,5.783,0,0,1,4.142,1.658l-1.17,1.17a4.2,4.2,0,0,0-2.972-1.187,4.388,4.388,0,0,0,0,8.775,4.093,4.093,0,0,0,3.054-1.2,3.418,3.418,0,0,0,.893-2.079h-3.946V28.88h5.558a4.9,4.9,0,0,1,.082,1.023,5.5,5.5,0,0,1-1.429,3.868A5.419,5.419,0,0,1,778.824,35.491Z",
    transform: "translate(-772.7 -23.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M1168.37,159.584a3.835,3.835,0,1,1-3.835-3.884A3.8,3.8,0,0,1,1168.37,159.584Zm-1.674,0a2.169,2.169,0,1,0-2.161,2.357A2.222,2.222,0,0,0,1166.7,159.584Z",
    transform: "translate(-1148.014 -151.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M1431.27,159.481a3.836,3.836,0,1,1-3.835-3.884A3.8,3.8,0,0,1,1431.27,159.481Zm-1.674,0a2.169,2.169,0,1,0-2.161,2.357A2.222,2.222,0,0,0,1429.6,159.481Z",
    transform: "translate(-1402.318 -151.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M1694.441,155.635v6.987c0,2.877-1.69,4.044-3.7,4.044a3.7,3.7,0,0,1-3.443-2.292l1.494-.618a2.136,2.136,0,0,0,1.965,1.38c1.285,0,2.079-.794,2.079-2.292v-.553h-.065a2.662,2.662,0,0,1-2.047.876,3.888,3.888,0,0,1,0-7.768,2.711,2.711,0,0,1,2.047.86h.065v-.634h1.609Zm-1.51,3.672a2.195,2.195,0,0,0-2.079-2.374,2.366,2.366,0,0,0,0,4.715A2.177,2.177,0,0,0,1692.931,159.307Z",
    transform: "translate(-1657.106 -151.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M1955.507,36.5V47.937H1953.8V36.5Z",
    transform: "translate(-1915.184 -36.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M2042.905,160.769l1.331.876a3.858,3.858,0,0,1-3.234,1.723,3.756,3.756,0,0,1-3.8-3.884,3.562,3.562,0,0,1,6.938-1.416l.18.438-5.2,2.145a1.982,1.982,0,0,0,1.883,1.187A2.213,2.213,0,0,0,2042.905,160.769Zm-4.093-1.4,3.476-1.445a1.511,1.511,0,0,0-1.445-.827A2.142,2.142,0,0,0,2038.812,159.37Z",
    transform: "translate(-1995.857 -151.278)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M119.087,0H108.039A1.743,1.743,0,0,0,106.3,1.739V3.479h13.467a1.743,1.743,0,0,1,1.739,1.739v-2.8A2.416,2.416,0,0,0,119.087,0Z",
    transform: "translate(-102.824)",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M2.419,0A2.427,2.427,0,0,0,0,2.419v6a1.743,1.743,0,0,0,1.739,1.739H3.479V1.739A1.743,1.743,0,0,1,5.218,0Z",
    transform: "translate(0)",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M2.419,262.615H13.467a1.743,1.743,0,0,0,1.739-1.739v-1.739H1.739A1.738,1.738,0,0,1,0,257.4v2.812a2.413,2.413,0,0,0,2.419,2.4Z",
    transform: "translate(0 -248.984)",
    fill: "#fbbc04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M414.6,116.455a2.427,2.427,0,0,0,2.419-2.419v-6a1.743,1.743,0,0,0-1.739-1.739h-1.739v8.416a1.741,1.741,0,0,1-1.739,1.739Z",
    transform: "translate(-398.336 -102.824)",
    fill: "#ea4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCast);
export default __webpack_public_path__ + "static/media/google-cast.802a8c4718429c198927f3e20db342c1.svg";
export { ForwardRef as ReactComponent };